import { Injectable, Optional, SkipSelf } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {

  get currentLocale(): string {
    return this.translate.currentLang;
  }

  constructor(
    private translate: TranslateService) {
  }
}
